module.exports = __webpack_public_path__ + "assets/2f0dba0aa61a84eedac8f6f033d222b2.jpg";